"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = interopDefault;

// https://github.com/moment/moment/issues/3650
function interopDefault(m) {
  return m.default || m;
}